module.exports = __webpack_public_path__ + "img/cashback.185f5d93.svg";